import { answerQuiz } from 'src/api/quizAnswers/quizAnswers'
import { QuestionAnswerPayload } from 'src/api/quizAnswers/types'
import { InitialQuizAnswersKey } from 'src/constants/localStorageKeys'

export const sendInitialQuizAnswers = async () => {
  const initialQuizAnswers = localStorage.getItem(InitialQuizAnswersKey)

  if (initialQuizAnswers) {
    try {
      const parsedInitialQuizAnswers = JSON.parse(
        initialQuizAnswers
      ) as QuestionAnswerPayload[]

      await answerQuiz(parsedInitialQuizAnswers)
    } catch (error) {
      console.error(error)
    }
    localStorage.removeItem(InitialQuizAnswersKey)
  }
}
